export default __webpack_public_path__ + "static/media/email.0d2a4c7e.svg";